import { AGENT_PIN_ENABLED } from '../../config/features';
import { isAgentUser } from '../../auth/loginDestination';
import { canViewAgentDashboard, canViewAgentWallet } from '../../auth/loginDestination';
import '../css/app.css'
import '../css/common.css'
import '../css/main.css'
import { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom"
import {
    LayoutDashboard, ChevronDown, NotebookPen, CircleDollarSign, FilePenLine, CalendarCheck, Users, HandCoins, AlarmClockCheck, ClipboardCheck, ClipboardX, ClipboardList,
    FileText, KeyRound, Crown, Network, UserSearch, CreditCard, Siren, UserRoundPlus, UserRoundCheck, MonitorSmartphone, Settings, Banknote, Receipt, Wallet, ShieldOff, FileSearch
} from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { change_Total_Search } from '../../store';
import { NOTI_BYPASS_ENABLED, MERCHANT_TRANSFER_CONTROL_ENABLED } from '../../config/features';

function AdminSidebar() {
    let navigate = useNavigate();
    let location = useLocation();
    let dispatch = useDispatch();

    const Current_Location = useSelector((state) => { return state.Current_Location.value });
    const MyData = useSelector((state) => { return state.MyData })
    const anthScreen = useSelector((state) => { return state.anthScreen })
    const brand = useSelector((state) => state.brand);
    const canViewMerchantTerminalFee = MyData?.role == "SUPER" && (anthScreen.includes("단말기비 관리") || brand?.key === "fast");
    const canManageNotiBypassTargets =
        NOTI_BYPASS_ENABLED &&
        ["SUPER", "ADMIN"].includes(MyData?.role) &&
        anthScreen.includes("오앤유 관리");
    const adminMenuDefaultPath = MyData?.role == "SUPER" ? '/admin' : '/notiBypassTargets';
    const showSettlementHoldMenu = false;

    const [btn, setBtn] = useState([false, false, false, false, false, false, false])
    const [cur, setCur] = useState(-1)

    const searchInputRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            // `/` 키 감지 (Shift 눌렀을 경우 제외)
            if (e.key === '/' && !e.shiftKey) {
                const tag = document.activeElement.tagName.toLowerCase();
                const isInputActive = ['input', 'textarea'].includes(tag) || document.activeElement.isContentEditable;

                if (!isInputActive) {
                    e.preventDefault(); // 기본 슬래시 입력 막기
                    searchInputRef.current?.focus();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, []);

    const onClickBtn = (e) => {
        let arr = [false, false, false, false, false, false, false]
        for (let i = 0; i < 7; i++) {
            if (e === i) {
                if (btn[i]) arr[i] = false
                else arr[i] = true
            }
            else arr[i] = btn[i]
        }
        setBtn(arr)
    }

    const onFirstBtn = (e) => {
        let arr = [false, false, false, false, false, false, false]
        for (let i = 0; i < 7; i++) {
            if (e === i) arr[i] = true
        }
        setBtn(arr)
    }

    useEffect(() => {
        if (Current_Location) {
            if (Current_Location == "대시보드") { setCur(0); onFirstBtn(-1) }
            else if (Current_Location == "거래내역") { setCur(1); onFirstBtn(-1) }

            else if (Current_Location == "정산달력") { setCur(2); onFirstBtn(1) }
            else if (Current_Location == "가맹점 정산내역") { setCur(3); onFirstBtn(1) }
            else if (Current_Location == "에이전트 정산내역") { setCur(4); onFirstBtn(1) }
            else if (Current_Location == "에이전트 정산") { setCur(50); onFirstBtn(1) }
            else if (Current_Location == "상세정보") { setCur(5); onFirstBtn(1) }
            else if (Current_Location == "정산보류내역") { setCur(30); onFirstBtn(1) }
            else if (Current_Location == "정산확정내역") { setCur(31); onFirstBtn(1) }
            else if (Current_Location == "입금대기내역") { setCur(32); onFirstBtn(1) }
            else if (Current_Location == "영업자입금대기내역") { setCur(34); onFirstBtn(1) }
            else if (Current_Location == "입금확정내역") { setCur(33); onFirstBtn(1) }
            else if (Current_Location == "영업자입금확정내역") { setCur(35); onFirstBtn(1) }

            else if (Current_Location == "바우처관리") { setCur(40); onFirstBtn(5) }
            else if (Current_Location == "바우처가맹점관리") { setCur(41); onFirstBtn(5) }

            else if (Current_Location == "가맹점") { setCur(8); onFirstBtn(4) }
            else if (Current_Location == "가맹점 등록") { setCur(22); onFirstBtn(4) }
            else if (Current_Location == "잠긴 계정 관리") { setCur(64); onFirstBtn(4) }

            else if (Current_Location == "통합에이전트") { setCur(9); onFirstBtn(-1) }
            else if (Current_Location == "영업자 현황판") { setCur(66); onFirstBtn(-1) }
            else if (Current_Location == "지갑") { setCur(51); onFirstBtn(-1) }

            else if (Current_Location == "관리자 조회") { setCur(10); onFirstBtn(2) }
            else if (Current_Location == "수익 정산") { setCur(11); onFirstBtn(2) }
            else if (Current_Location == "위즈페이 계좌") { setCur(60); onFirstBtn(2) }
            else if (Current_Location == "단말기 관리") { setCur(12); onFirstBtn(2) }
            else if (Current_Location == "단말기비 관리") { setCur(61); onFirstBtn(4) }
            else if (Current_Location == "입출금내역") { setCur(62); onFirstBtn(6) }
            else if (Current_Location == "지갑잔액현황") { setCur(65); onFirstBtn(6) }
            else if (Current_Location == "지급계좌 관리") { setCur(66); onFirstBtn(6) }
            else if (Current_Location == "지급계좌 입출금") { setCur(67); onFirstBtn(6) }
            else if (Current_Location == "직접 정산") { setCur(68); onFirstBtn(6) }
            else if (Current_Location == "수수료안내") { setCur(13); onFirstBtn(2) }
            else if (Current_Location == "고객센터") { setCur(14); onFirstBtn(2) }
            else if (Current_Location == "감사 로그") { setCur(70); onFirstBtn(2) }
            else if (Current_Location == "오앤유 관리") { setCur(71); onFirstBtn(2) }

            else if (Current_Location == "수기결제") { setCur(27); onFirstBtn(-1) }
            else if (Current_Location == "수기결제취소") { setCur(15); onFirstBtn(-1) }
            else if (Current_Location == "수기결제승인내역") { setCur(16); onFirstBtn(-1) }
            else if (Current_Location == "수기결제처리내역") { setCur(18); onFirstBtn(-1) }

            else if (Current_Location == "RM") { setCur(17); onFirstBtn(3) }
            else if (Current_Location == "할부관리") { setCur(19); onFirstBtn(3) }
            else if (Current_Location == "블랙리스트카드") { setCur(20); onFirstBtn(3) }
            else if (Current_Location == "가맹점갱신관리") { setCur(23); onFirstBtn(3) }
            else if (Current_Location == "RM설정") { setCur(24); onFirstBtn(3) }
            else if (Current_Location == "무실적가맹점") { setCur(25); onFirstBtn(3) }
            else if (Current_Location == "RM대시보드") { setCur(26); onFirstBtn(3) }
            else if (Current_Location == "이상거래관리") { setCur(28); onFirstBtn(3) }

            if (Current_Location != "거래내역") {
                dispatch(change_Total_Search(""))
                setSearch("")
            }
        }
    }, [Current_Location])

    const [search, setSearch] = useState("")

    const onChangeSearch = (e) => {
        const value = e.target.value;
        setSearch(value);
    };

    const onClickSearch = () => {
        dispatch(change_Total_Search(search))
        navigate('/paylist')
    }

    const targets = [
        "정산달력", "가맹점 마감", "가맹점 정산내역",
        "가맹점 입금", "에이전트 정산내역", "상세정보"
    ];

    const noneIncluded = targets.every(item => !anthScreen.includes(item))

    return (
        <div className="flex overflow-hidden sidebar" style={{ display: location.pathname == '/' ? "none" : "" }}>
            <nav className="side-nav" style={{ backgroundColor: "#f1f5f9", height: "100dvh", borderRight: "5px solid #fff" }}>
                {/* <div className={`side-menu`} style={{ border: "2px solid #b7b7b7", marginBottom: "0.5rem", paddingLeft: "0.5rem", backgroundColor: "#fff" }}>
                    {showSearchInput && (
                        <>
                            <input
                                ref={searchInputRef}
                                value={search}
                                onChange={onChangeSearch}
                                placeholder='통합검색'
                                style={{ width: "125px", backgroundColor: "transparent", paddingTop: "2px" }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onClickSearch();
                                    }
                                }}
                            />
                        </>
                    )}
                    <Search size={30} style={{ color: "gray", padding: "5px", cursor: "pointer" }} onClick={() => onClickSearch()} />
                </div> */}
                <ul>
                        {canViewAgentDashboard(MyData, anthScreen) && (
                        <li><Link to="/agentDashboard" className={`side-menu ${cur === 66 ? 'side-menu--active' : ''}`}><div className="side-menu__icon"><LayoutDashboard /></div><div className="side-menu__title"><span>현황판</span></div></Link></li>
                    )}
                    {MyData?.role === "SUPER" && anthScreen.includes("대시보드") && (
                        <li>
                            <Link to={`/dashboard`} className={`side-menu ${cur == 0 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <LayoutDashboard />
                                </div>
                                <div className="side-menu__title">
                                    <span>대시보드</span>
                                </div>
                            </Link>
                        </li>
                    )}
                    {anthScreen.includes("거래내역") && (
                        <li>
                            <Link to={`/paylist`} className={`side-menu ${cur == 1 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <NotebookPen />
                                </div>
                                <div className="side-menu__title">
                                    <span>거래</span>
                                </div>
                            </Link>
                        </li>
                    )}
                    {
                        !noneIncluded
                            ?
                            <li>
                                <Link to={MyData?.role == "SUPER" ? `/payDetailList` : `payDetailList`} className={`side-menu ${cur == 2 || cur == 3 || cur == 4 || cur == 5 || cur == 30 || cur == 31 || cur == 32 || cur == 33 || cur == 34 || cur == 35 ? "side-menu--active" : ""}`} aria-expanded={isAgentUser(MyData) ? !!btn[1] : undefined} onClick={e => {if(isAgentUser(MyData)) e.preventDefault(); onClickBtn(1);}} >
                                    <div className="side-menu__icon">
                                        <CircleDollarSign />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>정산</span>
                                        <div className="side-menu__sub-icon">
                                            <ChevronDown />
                                        </div>
                                    </div>
                                </Link>
                                {
                                    btn[1]
                                        ?
                                        <ul className={`depth-2${isAgentUser(MyData) ? " agent-settlement-menu" : ""}`}>
                                            {/* {MyData?.role == "SUPER" && (
                                                <>
                                                    {anthScreen.includes("정산달력") && (
                                                        <li>
                                                            <Link to={`/integrateSettlement`} className={`side-menu ${cur == 2 ? "side-menu--active sideActive" : ""}`}>
                                                                <div className="side-menu__icon">
                                                                    <CalendarCheck />
                                                                </div>
                                                                <div className="side-menu__title">
                                                                    <span>월별 달력</span>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    )}
                                                </>
                                            )} */}
                                            {anthScreen.includes("상세정보") && (
                                                <>
                                                    <li>
                                                        <Link to={`/payDetailList`} aria-current={isAgentUser(MyData) && location.pathname === "/payDetailList" ? "page" : undefined} className={`side-menu ${cur == 5 ? "side-menu--active sideActive" : ""}`}>
                                                            <div className="side-menu__icon">
                                                                <FileText />
                                                            </div>
                                                            <div className="side-menu__title">
                                                                <span>승인내역</span>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                </>
                                            )}
                                            {(MyData?.role == "SUPER" || MyData?.role == "SM") && (
                                                <>
                                                    {anthScreen.includes("상세정보") &&
                                                        (brand.tier === "primary"
                                                            || MyData?.admin_id === "happyS" || MyData?.role == "SUPER"
                                                        ) && (
                                                            <>
                                                                {showSettlementHoldMenu && (
                                                                    <>
                                                                        <li>
                                                                            <Link to={`/settlementPending`} className={`side-menu ${cur == 30 ? "side-menu--active sideActive" : ""}`}>
                                                                                <div className="side-menu__icon">
                                                                                    <FileText />
                                                                                </div>
                                                                                <div className="side-menu__title">
                                                                                    <span>정산보류</span>
                                                                                </div>
                                                                            </Link>
                                                                        </li>
                                                                        <li>
                                                                            <Link to={`/settlementConfirm`} className={`side-menu ${cur == 31 ? "side-menu--active sideActive" : ""}`}>
                                                                                <div className="side-menu__icon">
                                                                                    <FileText />
                                                                                </div>
                                                                                <div className="side-menu__title">
                                                                                    <span>정산확정목록</span>
                                                                                </div>
                                                                            </Link>
                                                                        </li>
                                                                    </>
                                                                )}
                                                                <li className="depth-2-divider"></li>
                                                                <li>
                                                                    <Link to={`/settlementDepositStay`} className={`side-menu ${cur == 32 ? "side-menu--active sideActive" : ""}`}>
                                                                        <div className="side-menu__icon">
                                                                            <FileText />
                                                                        </div>
                                                                        <div className="side-menu__title">
                                                                            <span>가맹점 입금예정</span>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={`/settlementDeposits`} className={`side-menu ${cur == 33 ? "side-menu--active sideActive" : ""}`}>
                                                                        <div className="side-menu__icon">
                                                                            <FileText />
                                                                        </div>
                                                                        <div className="side-menu__title">
                                                                            <span>가맹점 입금확정</span>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                                {anthScreen.includes("가맹점 정산내역") && (
                                                                    <li>
                                                                        <Link to={`/settlements`} aria-current={isAgentUser(MyData) && location.pathname === "/settlements" ? "page" : undefined} className={`side-menu ${cur == 3 ? "side-menu--active sideActive" : ""}`}>
                                                                            <div className="side-menu__icon">
                                                                                <FilePenLine />
                                                                            </div>
                                                                            <div className="side-menu__title">
                                                                                <span>가맹점 내역</span>
                                                                            </div>
                                                                        </Link>
                                                                    </li>
                                                                )}
                                                                <li className="depth-2-divider"></li>
                                                                <li>
                                                                    <Link to={`/settlementAgentDepositStay`} className={`side-menu ${cur == 34 ? "side-menu--active sideActive" : ""}`}>
                                                                        <div className="side-menu__icon">
                                                                            <FileText />
                                                                        </div>
                                                                        <div className="side-menu__title">
                                                                            <span>에이전트 입금예정</span>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link to={`/settlementAgentDeposits`} className={`side-menu ${cur == 35 ? "side-menu--active sideActive" : ""}`}>
                                                                        <div className="side-menu__icon">
                                                                            <FileText />
                                                                        </div>
                                                                        <div className="side-menu__title">
                                                                            <span>에이전트 입금확정</span>
                                                                        </div>
                                                                    </Link>
                                                                </li>
                                                                {anthScreen.includes("에이전트 정산내역") && (
                                                                    <li>
                                                                        <Link to={`/settlementsAgent`} aria-current={isAgentUser(MyData) && location.pathname === "/settlementsAgent" ? "page" : undefined} className={`side-menu ${cur == 4 ? "side-menu--active sideActive" : ""}`}>
                                                                            <div className="side-menu__icon">
                                                                                <FilePenLine />
                                                                            </div>
                                                                            <div className="side-menu__title">
                                                                                <span>에이전트 내역</span>
                                                                            </div>
                                                                        </Link>
                                                                    </li>
                                                                )}
                                                            </>
                                                        )}
                                                </>
                                            )}
                                            {/* 가맹점 정산내역이 있지만 입금예정/입금확정 메뉴가 없는 경우 */}
                                            {anthScreen.includes("가맹점 정산내역") &&
                                                !((MyData?.role == "SUPER" || MyData?.role == "SM") &&
                                                    anthScreen.includes("상세정보") &&
                                                    (brand.tier === "primary"
                                                        || MyData?.admin_id === "happyS" || MyData?.role == "SUPER"
                                                    )) && (
                                                <li>
                                                    <Link to={`/settlements`} aria-current={isAgentUser(MyData) && location.pathname === "/settlements" ? "page" : undefined} className={`side-menu ${cur == 3 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <FilePenLine />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>가맹점 내역</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* 에이전트 정산내역이 있지만 입금예정/입금확정 메뉴가 없는 경우 */}
                                            {anthScreen.includes("에이전트 정산내역") &&
                                                !((MyData?.role == "SUPER" || MyData?.role == "SM") &&
                                                    anthScreen.includes("상세정보") &&
                                                    (brand.tier === "primary"
                                                        || MyData?.admin_id === "happyS" || MyData?.role == "SUPER"
                                                    )) && (
                                                <li>
                                                    <Link to={`/settlementsAgent`} aria-current={isAgentUser(MyData) && location.pathname === "/settlementsAgent" ? "page" : undefined} className={`side-menu ${cur == 4 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <FilePenLine />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>에이전트 내역</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {MyData?.role == "SUPER" && anthScreen.includes("수익 정산") && (
                                                <li>
                                                    <Link to={`/agentSettlement`} className={`side-menu ${cur == 50 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <FilePenLine />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>에이전트 정산</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                        </ul>
                                        :
                                        ""
                                }
                            </li>
                            :
                            ""
                    }

                    {/* 바우처지갑 - 숨김 처리
                    {anthScreen.includes("상세정보") &&
                        (brand.tier === "primary"
                            || MyData?.admin_id === "happyS" || MyData?.role == "SUPER"
                        ) && (
                            <li>
                                <Link to={`/settlementVoucher`} className={`side-menu ${cur == 40 || cur == 41 ? "side-menu--active" : ""}`} onClick={() => onClickBtn(5)} >
                                    <div className="side-menu__icon">
                                        <CircleDollarSign />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>바우처지갑</span>
                                        <div className="side-menu__sub-icon">
                                            <ChevronDown />
                                        </div>
                                    </div>
                                </Link>
                                {
                                    btn[5]
                                        ?
                                        <ul className="depth-2">
                                            <li>
                                                <Link to={`/settlementVoucher`} className={`side-menu ${cur == 40 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <FilePenLine />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>잔액 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={`/settlementVoucherSub`} className={`side-menu ${cur == 41 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <FilePenLine />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>가맹점 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        </ul>
                                        :
                                        ""
                                }
                            </li>
                        )}
                    */}

                    {brand?.key === "baekma" ? (
                        <li>
                            <Link to={`/submerchants`} className={`side-menu ${cur == 8 || cur == 61 || cur == 64 ? "side-menu--active" : ""}`} onClick={() => { if (!btn[4]) onClickBtn(4); }}>
                                <div className="side-menu__icon">
                                    <Network />
                                </div>
                                <div className="side-menu__title">
                                    <span>가맹점</span>
                                    <div className="side-menu__sub-icon">
                                        <ChevronDown />
                                    </div>
                                </div>
                            </Link>
                            {
                                btn[4]
                                    ?
                                    <ul className="depth-2">
                                        {anthScreen.includes("가맹점") && (
                                            <li>
                                                <Link to={`/submerchants`} className={`side-menu ${cur == 8 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <UserRoundCheck />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>가맹점 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {canViewMerchantTerminalFee && (
                                            <li>
                                                <Link to={`/merchantTerminalFee`} className={`side-menu ${cur == 61 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <Receipt />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>단말기비 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {MyData?.role === "SUPER" && (
                                            <li>
                                                <Link to={`/lockedAccounts`} className={`side-menu ${cur == 64 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <ShieldOff />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>잠긴 계정 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                    :
                                    ""
                            }
                        </li>
                    ) : (
                        <li>
                            <Link to={`/submerchants`} className={`side-menu ${cur == 8 || cur == 22 || cur == 61 || cur == 64 ? "side-menu--active" : ""}`} onClick={() => { if (!btn[4]) onClickBtn(4); }} >
                                <div className="side-menu__icon">
                                    <Network />
                                </div>
                                <div className="side-menu__title">
                                    <span>가맹점</span>
                                    <div className="side-menu__sub-icon">
                                        <ChevronDown />
                                    </div>
                                </div>
                            </Link>
                            {
                                btn[4]
                                    ?
                                    <ul className="depth-2">
                                        {anthScreen.includes("가맹점") && (
                                            <li>
                                                <Link to={`/submerchants`} className={`side-menu ${cur == 8 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <UserRoundCheck />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>가맹점 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {anthScreen.includes("할부관리") && (
                                            <li>
                                                <Link to={`/createMerchants`} className={`side-menu ${cur == 22 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <UserRoundPlus />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>가맹점 등록</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {canViewMerchantTerminalFee && (
                                            <li>
                                                <Link to={`/merchantTerminalFee`} className={`side-menu ${cur == 61 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <Receipt />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>단말기비 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {MyData?.role === "SUPER" && (
                                            <li>
                                                <Link to={`/lockedAccounts`} className={`side-menu ${cur == 64 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <ShieldOff />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>잠긴 계정 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                    :
                                    ""
                            }
                        </li>
                    )}

                    {anthScreen.includes("통합에이전트") && (
                        <li>
                            <Link to={`/integrateAgent`} className={`side-menu ${cur == 9 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <Crown />
                                </div>
                                <div className="side-menu__title">
                                    <span>에이전트</span>
                                </div>
                            </Link>
                        </li>
                    )}
                    {canViewAgentWallet(MyData, anthScreen) && (
                        <li>
                            <Link to={`/agentWallet`} className={`side-menu ${cur == 51 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <Banknote />
                                </div>
                                <div className="side-menu__title">
                                    <span>지갑</span>
                                </div>
                            </Link>
                        </li>
                    )}
                    {anthScreen.includes("수기결제") && (
                        <li>
                            <Link to={`/sugiManage`} className={`side-menu ${cur == 27 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <ClipboardCheck />
                                </div>
                                <div className="side-menu__title">
                                    <span>{MyData?.role == "SUPER" ? "수기 결제" : "수기 신청"}</span>
                                </div>
                            </Link>
                        </li>
                    )}
                    {/* {anthScreen.includes("수기결제취소") && (
                        <li>
                            <Link to={`/sugiCancelManage`} className={`side-menu ${cur == 15 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <ClipboardX />
                                </div>
                                <div className="side-menu__title">
                                    <span>{MyData?.role == "SUPER" ? "수기 취소" : "수기 취소 신청"}</span>
                                </div>
                            </Link>
                        </li>
                    )} */}
                    {anthScreen.includes("수기결제승인내역") && (
                        <li>
                            <Link to={`/sugiListManage`} className={`side-menu ${cur == 16 ? "side-menu--active" : ""}`} data-id="main">
                                <div className="side-menu__icon">
                                    <ClipboardList />
                                </div>
                                <div className="side-menu__title">
                                    <span>수기 승인/취소</span>
                                </div>
                            </Link>
                        </li>
                    )}
                    {
                        MyData?.role == "SUPER"
                            ?
                            <>
                                {
                                    anthScreen.includes("수기결제처리내역") && (
                                        <li>
                                            <Link to={`/sugiHistoryManage`} className={`side-menu ${cur == 18 ? "side-menu--active" : ""}`} data-id="main">
                                                <div className="side-menu__icon">
                                                    <ClipboardList />
                                                </div>
                                                <div className="side-menu__title">
                                                    <span>수기 처리내역</span>
                                                </div>
                                            </Link>
                                        </li>
                                    )
                                }
                            </>
                            :
                            ""
                    }

                    {MyData?.role == "SUPER" && (MERCHANT_TRANSFER_CONTROL_ENABLED || anthScreen.includes("입출금내역") || anthScreen.includes("지갑잔액현황") || anthScreen.includes("지급계좌관리") || anthScreen.includes("지급계좌입출금") || anthScreen.includes("직접정산")) && (
                        <li>
                            <Link className={`side-menu ${cur == 62 || cur == 65 || cur == 66 || cur == 68 ? "side-menu--active" : ""}`} onClick={() => onClickBtn(6)}>
                                <div className="side-menu__icon">
                                    <Wallet />
                                </div>
                                <div className="side-menu__title">
                                    <span>계좌관리</span>
                                    <div className="side-menu__sub-icon">
                                        <ChevronDown />
                                    </div>
                                </div>
                            </Link>
                            {
                                btn[6]
                                    ?
                                    <ul className="depth-2">
                                        {(anthScreen.includes("지급계좌관리") || anthScreen.includes("지급계좌입출금")) && (
                                            <li>
                                                <Link to={`/payoutAccountManage`} className={`side-menu ${cur == 66 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <Wallet />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>지급계좌 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {anthScreen.includes("직접정산") && (
                                            <li>
                                                <Link to={`/directSettlement`} className={`side-menu ${cur == 68 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <Banknote />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>직접 정산</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {(anthScreen.includes("지급계좌관리") || anthScreen.includes("지급계좌입출금") || anthScreen.includes("직접정산")) &&
                                            (anthScreen.includes("지갑잔액현황") || anthScreen.includes("입출금내역")) &&
                                            <li className="depth-2-divider" />
                                        }
                                        {MERCHANT_TRANSFER_CONTROL_ENABLED && <li><Link to="/walletTransferControl" className={`side-menu ${location.pathname === '/walletTransferControl' ? 'side-menu--active sideActive' : ''}`}><div className="side-menu__icon"><ShieldOff /></div><div className="side-menu__title"><span>지갑 출금 접수 제어</span></div></Link></li>}
                                        {anthScreen.includes("지갑잔액현황") && (
                                            <li>
                                                <Link to={`/walletBalance`} className={`side-menu ${cur == 65 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <Wallet />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>지갑 관리</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                        {anthScreen.includes("입출금내역") && (
                                            <li>
                                                <Link to={`/walletTransactionHistory`} className={`side-menu ${cur == 62 ? "side-menu--active sideActive" : ""}`}>
                                                    <div className="side-menu__icon">
                                                        <Receipt />
                                                    </div>
                                                    <div className="side-menu__title">
                                                        <span>지갑 입출금</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                    :
                                    ""
                            }
                        </li>
                    )}
                    {
                        MyData?.role == "SUPER" && brand?.key !== "baekma"
                            ?
                            <li>
                                <Link to={`/riskTrx`} className={`side-menu ${cur == 17 || cur == 19 || cur == 20 || cur == 21 || cur == 23 || cur == 24 || cur == 25 || cur == 26 || cur == 28 ? "side-menu--active" : ""}`} onClick={() => onClickBtn(3)} >
                                    <div className="side-menu__icon">
                                        <Siren />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>RM</span>
                                        <div className="side-menu__sub-icon">
                                            <ChevronDown />
                                        </div>
                                    </div>
                                </Link>
                                {
                                    btn[3]
                                        ?
                                        <ul className="depth-2">
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link to={`/riskDashboard`} className={`side-menu ${cur == 26 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <LayoutDashboard />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>RM 대시보드</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {anthScreen.includes("RM") && (
                                                <li>
                                                    <Link to={`/riskTrx`} className={`side-menu ${cur == 28 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <AlarmClockCheck />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>이상 거래 관리</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link to={`/riskQuotaManage`} className={`side-menu ${cur == 19 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <AlarmClockCheck />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>할부 관리</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link to={`/riskBlackListManage`} className={`side-menu ${cur == 20 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <CreditCard />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>블랙리스트카드</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link to={`/riskUnsoldMerchant`} className={`side-menu ${cur == 25 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <Network />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>무실적가맹점</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link to={`/riskSubmerchants`} className={`side-menu ${cur == 23 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <Network />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>가맹점 갱신 관리</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link to={`/riskSetting`} className={`side-menu ${cur == 24 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <Settings />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>RM 설정</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                        </ul>
                                        :
                                        ""
                                }
                            </li>
                            :
                            ""
                    }
                    {
                        (MyData?.role == "SUPER" || canManageNotiBypassTargets)
                            ?
                            <li>
                                <Link to={adminMenuDefaultPath} className={"side-menu " + (cur == 10 || cur == 11 || cur == 60 || cur == 12 || cur == 13 || cur == 14 || cur == 70 || cur == 71 ? "side-menu--active" : "")} onClick={() => onClickBtn(2)} >
                                    <div className="side-menu__icon">
                                        <Users />
                                    </div>
                                    <div className="side-menu__title">
                                        <span>관리자</span>
                                        <div className="side-menu__sub-icon">
                                            <ChevronDown />
                                        </div>
                                    </div>
                                </Link>
                                {
                                    btn[2]
                                        ?
                                        <ul className="depth-2">
                                            {MyData?.role == "SUPER" && anthScreen.includes("관리자 조회") && (
                                                <li>
                                                    <Link to={`/admin`} className={`side-menu ${cur == 10 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <UserSearch />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>관리자 조회</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {MyData?.role == "SUPER" && anthScreen.includes("수익 정산") && (
                                                <li>
                                                    <Link to={`/profitSettlement`} className={`side-menu ${cur == 11 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <Banknote />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>수익 정산</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {MyData?.role == "SUPER" && anthScreen.includes("위즈페이 계좌") && (
                                                <li>
                                                    <Link to={`/masterAccount`} className={`side-menu ${cur == 60 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <Banknote />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>위즈페이 계좌</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {anthScreen.includes("단말기 관리") && (
                                                <li>
                                                    <Link to={`/product`} className={`side-menu ${cur == 12 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <MonitorSmartphone />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>터미널 관리</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {MyData?.role == "SUPER" && anthScreen.includes("수수료안내") && (
                                                <li>
                                                    <Link to={`/feeNotice`} className={`side-menu ${cur == 13 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <HandCoins />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>수수료안내</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {MyData?.role == "SUPER" && anthScreen.includes("감사 로그") && (
                                                <li>
                                                    <Link to={`/auditLog`} className={`side-menu ${cur == 70 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <FileSearch />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>감사 로그</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {canManageNotiBypassTargets && (
                                                <li>
                                                    <Link to={`/notiBypassTargets`} className={`side-menu ${cur == 71 ? "side-menu--active sideActive" : ""}`}>
                                                        <div className="side-menu__icon">
                                                            <Settings />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>오앤유 관리</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {anthScreen.includes("고객센터") && (
                                                <li>
                                                    <Link to={`/help`} className={`side-menu ${cur == 14 ? "side-menu--active sideActive" : ""}`} data-id="main">
                                                        <div className="side-menu__icon">
                                                            <MessageCircleQuestion />
                                                        </div>
                                                        <div className="side-menu__title">
                                                            <span>고객센터</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            )} */}
                                        </ul>
                                        :
                                        ""
                                }
                            </li>
                            :
                            ""
                    }

                    {/* <div className="customer-info">
                        {
                            windowtypeM
                                ?
                                <>
                                    <div className="cust-text">CUSTOMER CENTER</div>
                                    <div className="cust-phone">
                                        <PhoneCall /><span>1600-4406</span>
                                    </div>
                                    <div className="cust-work"><span>평일</span>09:00 - 18:00</div>
                                    <div className="cust-rest"><span>휴무</span>토/일/공휴일 휴무</div>
                                </>
                                :
                                <PhoneCall />
                        }
                    </div> */}
                    {AGENT_PIN_ENABLED && isAgentUser(MyData) && <li><Link to="/agentPin" className="side-menu"><div className="side-menu__icon"><KeyRound /></div><div className="side-menu__title">PIN 관리</div></Link></li>}
                </ul>
            </nav>
        </div>
    )
}

export default AdminSidebar;
